/* eslint-disable @typescript-eslint/no-namespace */
import {
  HttpErrorMessageCode,
  ICardToken,
  IThreeDSResponseInfo,
} from '@nibtravel/shared/util/models';

export namespace PaymentActions {
  export class Reset {
    public static readonly type = '[Payment] Reset State';
  }
  export class Update {
    public static readonly type = '[Payment] update State';
    constructor(
      public threeDSResponseInfo: IThreeDSResponseInfo,
      public cardToken: ICardToken,
      public paymentIds: string
    ) {}
  }
  export class SetErrors {
    public static readonly type = '[Payment] Set validation errors';
    constructor(
      public errorCode: HttpErrorMessageCode | string | undefined,
      public errorMessage?: string | undefined
    ) {}
  }
  export class ResetErrors {
    public static readonly type = '[Payment] Reset validation errors';
  }
}
